import React, { useState, useContext } from "react";
import { Table, TableRow, TableBody, TableHead } from "@material-ui/core";

import StyledTableCell, {
  HeadRow,
} from "../../common/styled-table-cell.component";
import {
  APP_INSIGHTS_EVENTS,
  MATCHING_ERRORS_MESSAGES,
  STOCKPILES_TABLE_COLUMNS_NUMBER,
} from "../../../constants";
import { GET_STOCKPILES_OUTPUT } from "../../../queries/stockpiles.gql";
import { MatchContext } from "../../../context";
import {
  SET_FORECASTED_STOCKPILE,
  SET_HIGHLIGHTED_ROWS,
} from "../../../reduce/actionTypes";
import StockpileHeader from "../../common/stockpile-header.component";
import DataCell from "../../common/data-cell.component";
import IntraTableMessage from "../../HOC/intratable-message/intratable-message.component";
import LoaderBar from "../../common/loader-bar.component";
import ErrorMessage from "../../common/error-message.component";
import useStyles from "../../tables-container/styles";
import useHighlightTableItem from "../../../utils/hooks/use-higlight-table-item";
import usePollStockpiles from "../../../utils/hooks/use-poll-stockpiles";
import prepareRowStyles from "../../../utils/prepare-row-styles";

const FilledTable = ({ stockpilesTableFeatures }): JSX.Element => {
  const classes = useStyles();
  const { state, dispatch } = useContext(MatchContext);
  const [hoveredStockpile, setHoveredStockpile] = useState("");
  const [hoveredParam, setHoveredParam] = useState("");
  const higlightItem = useHighlightTableItem();
  const { rows, error } = usePollStockpiles(
    GET_STOCKPILES_OUTPUT,
    stockpilesTableFeatures,
    "getOutputData"
  );

  const handleStockpileDoubleClick = (item: string) => {
    const value = item;
    if (state.stockpileName) {
      dispatch({
        type: SET_FORECASTED_STOCKPILE,
        payload: value,
      });
    }
  };

  return (
    <React.Fragment>
      {error ? (
        <ErrorMessage error={error} />
      ) : state.loadingStockpilesData ? (
        <IntraTableMessage>
          <LoaderBar />
        </IntraTableMessage>
      ) : rows[0] && !rows[0].stockpiles ? (
        <ErrorMessage
          error={error}
          customMessage={MATCHING_ERRORS_MESSAGES.MATCHING_ALGORYTHM}
        />
      ) : (
        <Table aria-label="customized table">
          <TableHead>
            <HeadRow>
              <StyledTableCell className={classes.paramCell} align="center">
                Parameter
              </StyledTableCell>
              <StockpileHeader
                data={rows}
                columnsNumber={STOCKPILES_TABLE_COLUMNS_NUMBER}
                handleStockpileDoubleClick={handleStockpileDoubleClick}
                handleStockpileHover={(item: string) =>
                  setHoveredStockpile(item)
                }
                hoveredStockpile={hoveredStockpile}
              />
            </HeadRow>
          </TableHead>
          <TableBody className={state.hideMatchingTable && "hidden"}>
            {rows.map((row: any, index) => (
              <TableRow
                key={row.feature}
                className={prepareRowStyles(row, state, hoveredParam, false)}
              >
                <StyledTableCell
                  align="center"
                  className={classes.dataCell}
                  onClick={() =>
                    higlightItem(
                      row.feature.toUpperCase(),
                      SET_HIGHLIGHTED_ROWS,
                      "highlightedRows",
                      APP_INSIGHTS_EVENTS.CHANGE_ROW_HIGHLIGHT
                    )
                  }
                  onMouseEnter={() =>
                    setHoveredParam(row.feature.toUpperCase())
                  }
                  onMouseLeave={() => setHoveredParam("")}
                >
                  {row.feature}
                </StyledTableCell>
                <DataCell
                  feature={row.feature}
                  stockpiles={row.stockpiles}
                  hoveredStockpile={hoveredStockpile}
                  handleStockpileHover={(item: string) =>
                    setHoveredStockpile(item)
                  }
                  handleStockpileDoubleClick={handleStockpileDoubleClick}
                />
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </React.Fragment>
  );
};

export default FilledTable;
